// extracted by mini-css-extract-plugin
export default {"btn":"BackButton_btn__BbIfU","icon":"BackButton_icon__kpCAa","text":"BackButton_text__gtESx","v_ghost":"BackButton_v_ghost__Zx5Vc","v_icon":"BackButton_v_icon__HObHo"};